import React, { FC } from "react";
import classNames from "classnames";

type FormCheckboxProps = {
  id?: string;
  label: string;
  description?: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
  className?: string;
};

const FormCheckbox: FC<FormCheckboxProps> = ({
  id,
  label,
  description,
  checked,
  onChange,
  className,
}) => {
  return (
    <label
      className={classNames(
        "flex items-center gap-2 text-sm text-gray-700 hover:bg-gray-50 px-2 py-1 rounded",
        className
      )}
    >
      <input
        id={id}
        type="checkbox"
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        className="h-4 w-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-600"
      />
      <span className="font-normal">{label}</span>
      {!!description && (
        <span className="text-xs text-gray-500 truncate">{description}</span>
      )}
    </label>
  );
};

export default FormCheckbox;
